<div class="status-wrap">
    <mat-form-field appearance="fill" class="status-{{ favorite.status }}">
        <!--    <mat-label>Statut du projet</mat-label>-->
        <mat-select disableOptionCentering [(ngModel)]="favorite.status" (ngModelChange)="edit($event)">
            <mat-option value="analyse"
                        class="status-value status-value-analyse">{{ commonService.getStatusLib('analyse') }}</mat-option>
            <mat-option value="contact"
                        class="status-value status-value-contact">{{ commonService.getStatusLib('contact') }}</mat-option>
            <mat-option value="visite"
                        class="status-value status-value-visite">{{ commonService.getStatusLib('visite') }}</mat-option>
            <mat-option value="offre"
                        class="status-value status-value-offre">{{ commonService.getStatusLib('offre') }}</mat-option>
            <mat-option value="offre_ok"
                        class="status-value status-value-offre_ok">{{ commonService.getStatusLib('offre_ok') }}</mat-option>
            <mat-option value="offre_ko"
                        class="status-value status-value-offre_ko">{{ commonService.getStatusLib('offre_ko') }}</mat-option>
            <mat-option value="sell"
                        class="status-value status-value-sell">{{ commonService.getStatusLib('sell') }}</mat-option>
            <mat-option value="abandon"
                        class="status-value status-value-abandon">{{ commonService.getStatusLib('abandon') }}</mat-option>
            <mat-option value="offre_reponse"
                        class="status-value status-value-offre_reponse">{{ commonService.getStatusLib('offre_reponse') }}</mat-option>
            <mat-option value="buy"
                        class="status-value status-value-buy">{{ commonService.getStatusLib('buy') }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
